

export default function ({data}) {
    return JSON.parse(data.replace(/'/g, '"')).sort().map(row => <p style={{margin: "0"}}>{row}</p>);
}